import Container from "react-bootstrap/Container";
import { Row, Col } from "react-bootstrap";
import Faq from "../components/Faq";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faHouse,
  faWallet,
  faCreditCard,
  faPiggyBank,
  faHeartPulse,
  faHandHoldingHeart,
} from "@fortawesome/free-solid-svg-icons";
import "../styles/dualEducation.css";
import FormSection from "../components/formsection";
import TileGrid from "../components/TileGrid";
import { RETAIL_ROUTES } from "../lib/siteMode";

const PRODUCTS = [
  {
    icon: faWallet,
    title: "Személyi kölcsön",
    description:
      "Szabad felhasználású hitel fedezet nélkül, gyors bírálattal, akár 24 órán belüli folyósítással.",
    to: RETAIL_ROUTES.szemelyiKolcson,
  },
  {
    icon: faHouse,
    title: "Lakáshitel",
    description:
      "Fix kamatozású hitelek, Otthon Start vagy CSOK Plusz? Segítünk megtalálni a megfelelő választást.",
    to: RETAIL_ROUTES.jelzaloghitel,
  },
  {
    icon: faCreditCard,
    title: "Bankszámla",
    description:
      "Hasonlítsd össze a díjakat, és spórolj akár 100 ezer forintot éves szinten.",
    to: RETAIL_ROUTES.bankszamla,
  },
  {
    icon: faHandHoldingHeart,
    title: "Támogatott termékek",
    description:
      "Babaváró hitel, Munkáshitel, CSOK Plusz — állami támogatású kedvezményes konstrukciók.",
    to: RETAIL_ROUTES.szemelyiKolcson,
  },
  {
    icon: faPiggyBank,
    title: "Nyugdíjmegtakarítás",
    description:
      "Önkéntes nyugdíjpénztár, nyugdíjbiztosítás vagy NYESZ? Segítünk kihasználni a maximális állami támogatásokat.",
    to: RETAIL_ROUTES.nyugdijmegtakaritas,
  },
  {
    icon: faHeartPulse,
    title: "Életbiztosítás",
    description:
      "Segítünk megtalálni a megfelelő életbiztosítást, ahol a havi díj mellett az ügyintézés egyszerűse is szempont.",
    to: RETAIL_ROUTES.eletbiztositas,
  },
];

export default function LakossagiHome() {
  return (
    <>
      <Container className="px-1 hero mx-md-auto">
        <h1 className="title ms-1 ms-md-0">
          Találd meg a legjobb ajánlatot
          <br />
          <span style={{ color: "#c7d2fe" }}>és spórolj százezreket!</span>
        </h1>

        <p className="subtitle mb-0 ms-1 ms-md-0">
          Hitelek, biztosítások, támogatások és bankszámla – egy helyen,
          objektíven összehasonlítva. Számolj kalkulátorainkkal, és kollégáink
          segítenek a legjobb ajánlat kiválasztásában!
          <br />
        </p>
      </Container>
      <Container id="termekek">
        <TileGrid items={PRODUCTS} />

        <section id="miert-mi" className=" mt-5">
          <h2 className="h2">Miért érdemes velünk intézni?</h2>
          <Row className="g-4 mt-2">
            <Col md={6}>
              <ul className="list check-list">
                <li className="mb-4">
                  <FontAwesomeIcon icon={faCheck} className="me-3" />
                  <div>
                    <strong>Bankfüggetlenség:</strong> Nem egyetlen bank
                    ajánlatát mutatjuk, hanem több pénzintézetet versenyeztetünk
                    érted.
                  </div>
                </li>
                <li className="mb-4">
                  <FontAwesomeIcon icon={faCheck} className="me-3" />
                  <div>
                    <strong>Díjmentes ügyintézés:</strong> Az ajánlatkérés és a
                    teljes körű tanácsadás számodra ingyenes.
                  </div>
                </li>
                <li className="mb-4">
                  <FontAwesomeIcon icon={faCheck} className="me-3" />
                  <div>
                    <strong>Online ügyintézés:</strong> Segítünk
                    hiteligénylésben és bankszámlanyitásban akár{" "}
                    <strong>teljesen online</strong>!
                  </div>
                </li>
              </ul>
            </Col>
            <Col md={6}>
              <ul className="list check-list">
                <li className="mb-4">
                  <FontAwesomeIcon icon={faCheck} className="me-3" />
                  <div>
                    <strong>Időmegtakarítás:</strong> Egyetlen adatközléssel
                    több bank ajánlatát is megkapod, sorban állás nélkül.
                  </div>
                </li>
                <li className="mb-4">
                  <FontAwesomeIcon icon={faCheck} className="me-3" />
                  <div>
                    <strong>Szakértői támogatás:</strong> Végigkísérünk az első
                    kalkulációtól a szerződéskötésig.
                  </div>
                </li>
                <li className="mb-4">
                  <FontAwesomeIcon icon={faCheck} className="me-3" />
                  <div>
                    <strong>Szakmai tapasztalat:</strong> Kollégáink több éves
                    szakmai múltja segít abban, hogy a megfelelő banki
                    kiszolgálásban legyen részed.
                  </div>
                </li>
              </ul>
            </Col>
          </Row>
        </section>

        <section id="faq" className="section pb-0">
          <h2 className="h2">Gyakran ismételt kérdések</h2>

          <Faq
            categories={[
              {
                key: "altalanos",
                label: "Általános",
                items: [
                  {
                    question: "Mennyibe kerül a szolgáltatás?",
                    answer:
                      "Az ügyfelek számára az ajánlatkérés, a bankok versenyeztetése és a teljes körű tanácsadás díjmentes. Kötelezettséget nem vállalsz azzal, hogy ajánlatot kérsz.",
                  },
                  {
                    question: "Mit tudok itt összehasonlítani?",
                    answer:
                      "Jelzáloghitelt, személyi kölcsönt és lakossági bankszámlát – mindegyikhez külön kalkulátort vagy összehasonlító táblázatot és részletes útmutatót találsz. Válaszd ki a fenti termékek közül, ami érdekel.",
                  },
                  {
                    question: "Mennyi idő alatt kapok visszajelzést?",
                    answer:
                      "Az űrlap elküldése után munkatársunk hamarosan felveszi veled a kapcsolatot, és egyeztet a számodra legkedvezőbb lehetőségekről. A pontos ügyintézési idő a választott terméktől függ.",
                  },
                ],
              },
            ]}
          />
        </section>
      </Container>
    </>
  );
}
